export default __webpack_public_path__ + "static/media/SFProDisplay-Thin.03046e4c.woff2";